import axios from 'axios';
import { setRequestHeader, handleNetworkError } from './tool';
import store from '@/store';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { getToken, removeToken } from './auth';
import router from '@/router';
const service = axios.create({
  //创建请求实例
  baseURL: process.env.VUE_APP_BASE_API,
  // 服务器根地址
  // baseURL: 'api', // 服务器根地址
  timeout: 15000 // 表示请求超时
});

// 请求拦截
service.interceptors.request.use(config => {
  // 请求成功 2xx 范围内的状态码都会触发该函数。
  // 设置请求头
  NProgress.start();
  config = setRequestHeader(config);
  //如果没有token
  if (store.getters.token) {
    config.headers.Authorization = getToken();
  }
  return config;
}, error => {
  // 请求失败 超出 2xx 范围的状态码都会触发该函数。
  NProgress.done();
  MessageBox('请求失败', 'error');
  return;
});

// 响应拦截
service.interceptors.response.use(response => {
  // 2xx
  // 响应成功关闭进度条
  NProgress.done();
  // handleNetworkError
  // 判断返回数据token在不在请求头里
  if (!response.headers.authorization) {
    response = response.data;
    let {
      code,
      message
    } = response;
    if (code != 20000) {
      handleNetworkError(message);
    }
    return response;
  } else {
    return response;
  }
}, error => {
  if (error.message == 'timeout of 6000ms exceeded') {
    MessageBox('请求超时', 'error');
  }
  if (error.response && error.response.data === "token无效!") {
    // 如果token无效
    removeToken();
    MessageBox('token过期！', 'error');
    router.replace('/login');
  }
  if (error.response && error.response.data === "用户不存在!") {
    removeToken();
    MessageBox('用户不存在', 'error');
    router.replace('/login');
  }
  MessageBox(error.message, 'error');
  NProgress.done();
  return Promise.reject(error);
});
export default service;